import React, {useEffect, useState} from "react";
import {Box, Button, Typography} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";
import {GeneralService} from "./GeneralService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {actionTypes, setLoginStateDispatch} from "../../context/reducer";

let page = 0
let pageSize = 15
const GeneralAdmin = () => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token} = useAuthState()

    const dispatch = useAuthDispatcher()

    const service = new GeneralService(token, loading, snackbar)

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, [])

    const [itemCount, setItemCount] = useState(0);
    const [fundsList, setFundsList] = useState([]);
    const [pageCount, setPageCount] = useState(0);

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getAvailableCashList(
            page,
            pageSize
        ).then(response => {
            loading(setLoadingStateDispatch(false))
            setPageCount(response.totalPage)
            setItemCount(response.numberOfItems)
            setFundsList([])

            response.data.map((item, index) => {
                setFundsList(prevState => [
                    ...prevState, {
                        id: item.id,
                        number: (page * pageSize) + index + 1,
                        fund_id: item.id,
                        name: item.name
                    }
                ])
            })

        }).catch(reason => {
            loading(setLoadingStateDispatch(false))
            ServerErrorHandler(reason, "خطا در دریافت لیست صندوق ها", snackbar, loading)
        })
    }


    function handleChange(event, value) {
        page = value - 1
        getDataFromServer()
    }

    return (
        <section className='pageContainer'>

            <Box className={`d-flex flex-row w-100`}
                 sx={{
                     margin: '1rem 0 1.2rem 0',
                     justifyContent: 'center',
                     alignContent: 'center',
                     alignItems: 'center'
                 }}>
                <section className='d-flex flex-column flex-nowrap flex-grow-1'
                         style={{alignItems: 'baseline'}}>
                    <Typography variant={"h5"}>
                        صندوق های در دسترس
                    </Typography>
                    {itemCount > 0 ?
                        <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                            {" " + itemCount + " صندوق ثبت شده "}
                        </Typography> :
                        ''}
                </section>
            </Box>
            <Box style={{display: "flex", flexDirection: "column", flexWrap: "wrap"}} sx={{margin: '0 0 1.2rem 0'}}>


                <CustomTable
                    title={"هیچ صندوقی ثبت نشده است."}
                    header={columns}
                    data={fundsList}
                    rowClicked={rowID => {
                        for (let i = 0; i < fundsList.length; i++) {
                            if (fundsList[i].id === rowID) {
                                dispatch({
                                    type: actionTypes.CHANGE_FUND,
                                    fundID: rowID,
                                    title: fundsList[i].name
                                })
                            }
                        }
                        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "صندوق پیشفرض با موفقیت تغییر کرد."))
                    }}
                />
                <Box className={"paginationContainer"}>
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>

            </Box>
        </section>
    )
}


export default GeneralAdmin

const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'fund_id', label: 'شناسه صندوق', align: 'right'},
    {id: 'name', label: 'نام صندوق', align: 'right'},
];